export function getApiOrigin(): string {
  const apiUrl = import.meta.env.VITE_API_URL || '/api'
  return apiUrl.replace(/\/api\/?$/, '')
}

export function resolveMediaUrl(url?: string | null): string | undefined {
  if (!url) return undefined

  if (/^https?:\/\//i.test(url)) {
    return url
  }

  if (url.startsWith('/')) {
    return `${getApiOrigin()}${url}`
  }

  return `${getApiOrigin()}/uploads/projects/${url}`
}
